import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

export interface ChannelLink {
  id: string;
  roomTypeId: string;
  roomType: string;
  active: boolean;
  /** only for those who may set the channel up */
  exportPath?: string;
  /** the address itself for managers; just "set" for others */
  importUrl: string | null;
  lastImportAt: string | null;
  lastImportOk: boolean | null;
  lastImportMessage: string | null;
  lastExportAt: string | null;
  upcoming: number;
}
export interface Channel {
  id: string;
  name: string;
  active: boolean;
  links: ChannelLink[];
}
export interface ChannelHold {
  id: string;
  channel: string;
  roomType: string;
  from: string;
  to: string;
  summary: string | null;
  oversold: boolean;
  flaggedOnArrival: boolean;
}

export const useChannels = () => useQuery({ queryKey: ['channels'], queryFn: () => api<{ roomTypes: { id: string; name: string }[]; channels: Channel[] }>('/channels') });
export const useChannelHolds = () => useQuery({ queryKey: ['channels', 'holds'], queryFn: () => api<{ holds: ChannelHold[] }>('/channel-holds').then((r) => r.holds) });

export function useChannelMutation<V, R = unknown>(run: (v: V) => Promise<R>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: run,
    // also after a failure: a calendar that could not be read is recorded on the link, and the screen must show it
    onSettled: async () => {
      // what is free to sell may have changed, so every availability on screen is refreshed too
      await Promise.all(['channels', 'availability', 'daily', 'bookings'].map((k) => qc.invalidateQueries({ queryKey: [k] })));
    },
  });
}

/** The full web address of our calendar for a channel, to paste into that channel's "import calendar" box. */
export const feedUrl = (exportPath: string): string => `${window.location.origin}/api${exportPath}`;
